import { HistoryOutlined } from '@mui/icons-material';
import { MapSearchResultItem } from 'components/maps';
import { useMapSearchHistory } from './useMapSearchHistory';
import { useMapBoxSearchContext } from '../MapSearchBoxContext';

export const MapSearchHistory: React.FC = () => {
  const mapSearchBoxContextValue = useMapBoxSearchContext();
  const { searchText } = mapSearchBoxContextValue;

  const { searchHistory, deleteSearchHistory } = useMapSearchHistory();

  if (searchText.length !== 0 || !searchHistory?.length) {
    return null;
  }

  return (
    <>
      {searchHistory.map((searchTerm, index) => (
        <MapSearchResultItem
          key={`${searchTerm}_${index}`}
          name={searchTerm}
          icon={<HistoryOutlined />}
          onDelete={() => deleteSearchHistory(searchTerm)}
          clearInput={false}
        />
      ))}
    </>
  );
};
